import { PropostasCasoVendasService } from "../../../Services/Vendas/Propostas/PropostasServices";
import { Controller } from "../../Controller";

export async function PropostasCasoVendasController(idCaso: number) {
    return Controller(PropostasCasoVendasService(idCaso));
}
